<template>
</template>

<script lang="tsx">
import { createComponent, computed, onBeforeMount, onBeforeUnmount } from '@vue/composition-api'
import { Store } from 'vuex'
import { useStore } from '../../store'
import router from '../../router/router'

export default createComponent({
    setup: (props, ctx) => {
        const store: Store<any> = useStore()

        let notify

        const isImporting = computed(() => store.state.shop.isImportingMemberData)
        const isImportingGoods = computed(() => store.state.shop.isImportingGoodsData)
        const routeArr = [ '/main/member/memberImport', '/main/goodsLibrary/goodsImport']


        onBeforeMount(() => {
            judgePath()
            if (isImporting.value) {
                store.dispatch('shop/checkImportData')
                    .finally(() => closeNotify())
            }
        })

        onBeforeUnmount(() => {
            closeNotify()
        })

        function init() {
            console.log('isImporting', isImporting)
            const isShow = isImporting.value
            const isShowGoods = isImportingGoods.value
            if (isShow && !notify) {
                showNotify()
            }
            if (isShowGoods && !notify) {
                showNotifyGoods()
            }
        }

        function judgePath() {
            startJudgePath((router as any).history.current)
            router.afterEach((to, from) => {
                startJudgePath(to)
            })
        }

        function startJudgePath(to) {
            if (!routeBoolean(routeArr, to.path)) {
              init()
            } else {
              closeNotify()
            }
        }

        function routeBoolean (routeArr, path) {
            return routeArr.some(el => {
                return path.includes(el)
            })
        }

        function showNotify() {
            const h = ctx.root.$createElement
            notify = ctx.root.$notify({
                title: '',
                position: 'bottom-left',
                customClass: '__alert_importing__',
                duration: 0,
                showClose: false,
                message: (
                    <div class="fx-v-center fs-14 color-333">
                        <i class="fs-16 el-icon-close" onClick={ () => notify.close() } />
                        <div class="fx-h-center" onClick={ () => { router.push('/main/member/memberImport'); notify.close() } }>
                            <h2 class="fw-600">会员数据导入中</h2>
                            <p class="fs-12 color-green">去查看>></p>
                        </div>
                    </div>
                )
            })
        }

        function showNotifyGoods() {
            const h = ctx.root.$createElement
            notify = ctx.root.$notify({
                title: '',
                position: 'bottom-left',
                customClass: '__alert_importing__',
                duration: 0,
                showClose: false,
                message: (
                    <div class="fx-v-center fs-14 color-333">
                        <i class="fs-16 el-icon-close" onClick={ () => notify.close() } />
                        <div class="fx-h-center" onClick={ () => { router.push('/main/goodsLibrary/goodsImport'); notify.close()} }>
                            <h2 class="fw-600">商品数据导入中</h2>
                            <p class="fs-12 color-green">去查看>></p>
                        </div>
                    </div>
                )
            })
        }

        function closeNotify() {
            if (notify) {
                notify.close()
                notify = null
            }
        }
    }
})
</script>

<style lang="scss">
.el-notification.__alert_importing__ {
    width: auto;
    padding: 0;

    .el-notification__group {
        margin: 0;

        .el-notification__content {
            margin: 0;
        }

        .fx-v-center {
            width: 150px;
            height: 70px;

            i {
                margin: 0 11px;
                cursor: pointer;
            }

            > div {
                flex-direction: column;
                height: 100%;
                cursor: pointer;
            }
        }
    }
}
</style>
